import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/vendor/flaticon.css';
import './css/vendor/fontawesome.min.css';
import './css/vendor/themify-icons.css';

import Home from './pages/Home';
import Home2 from './pages/Home2';
import Home3 from './pages/Home3';

import About_us from './pages/About_us';
import Services from './pages/Services';
import Services_2 from './pages/Services_2';
import Contact_01 from './pages/Contact_01';
import Contact_02 from './pages/Contact_02';
import Our_team from './pages/Our_team';
import About_us_2 from './pages/About_us_2';
import Team_details from './pages/Team_details';
import Pricing from './pages/Pricing';
import Dry_cleaning from './services/Dry_cleaning';
import Alterations_repairs from './services/Alterations_repairs';
import Commercial_laundry from './services/Commercial_laundry';
import Laundry_services from './services/Laundry_services';
import Leather_cleaning from './services/Leather_cleaning';
import Steam_iron from './services/Steam_iron';
import Our_case_study from './Case-study/Our_case_study';
import Case_study_details from './Case-study/Case_study_details';
import Blog from './Blog/Blog';
import Blog_grid_view from './Blog/Blog_grid_view';
import Blog_details from './Blog/Blog_details';


import ScrollToTop from './components/layout/Gotop';


function App() {
 
  return (
    <div className="page">
      <Router> 
        
        <Route exact path={`${process.env.PUBLIC_URL + '/'}`} component={ Home } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Home2'}`} component={ Home2 } /> 
        <Route exact path={`${process.env.PUBLIC_URL + '/Home3'}`} component={ Home3 } /> 

        <Route exact path={`${process.env.PUBLIC_URL + '/About_us'}`} component={ About_us } /> 
        <Route exact path={`${process.env.PUBLIC_URL + '/Services'}`} component={ Services } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Services_2'}`} component={ Services_2 } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Contact_01'}`} component={ Contact_01 } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Contact_02'}`} component={ Contact_02 } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Our_team'}`} component={ Our_team } />
        <Route exact path={`${process.env.PUBLIC_URL + '/About_us_2'}`} component={ About_us_2 } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Team_details'}`} component={ Team_details } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Pricing'}`} component={ Pricing } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Dry_cleaning'}`} component={ Dry_cleaning } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Alterations_repairs'}`} component={ Alterations_repairs } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Commercial_laundry'}`} component={ Commercial_laundry } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Laundry_services'}`} component={ Laundry_services } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Leather_cleaning'}`} component={ Leather_cleaning } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Steam_iron'}`} component={ Steam_iron } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Our_case_study'}`} component={ Our_case_study } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Case_study_details'}`} component={ Case_study_details } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Blog'}`} component={ Blog } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Blog_grid_view'}`} component={ Blog_grid_view } />
        <Route exact path={`${process.env.PUBLIC_URL + '/Blog_details'}`} component={ Blog_details } />
       

        <ScrollToTop />
      </Router>
    </div>
  );
}

export default App;


